"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fetch_1 = __importDefault(require("../fetch"));
const firebase_1 = require("../firebase");
/* Deixar mudanças para o futuro no useEffect */
/* eslint-disable react-hooks/exhaustive-deps */
const onUsuarioLoginDefault = ({ usuarioFirebase, pessoa, organizacao, }) => {
    /* Autenticação realizada com sucesso */
    console.log('Autenticação realizada com sucesso:', {
        usuarioFirebase,
        pessoa,
        organizacao,
    });
};
const onLogoutDefault = () => console.log('Logout realizado...');
const useAuth = ({ onUsuarioLogin = onUsuarioLoginDefault, onLogout = onLogoutDefault, }) => {
    const firebase = firebase_1.useFirebase();
    const [loading, setLoading] = react_1.useState(false);
    const dadosAutenticacaoEstadoInicial = {
        autenticar: () => undefined,
        pessoa: null,
        organizacao: null,
        usuarioFirebase: null,
        erro: null,
        possuiSenha: false,
        loading: false,
        signout: () => undefined,
        necessarioEnviarNomeDaMae: false,
        erroValidacaoNomeDaMae: false,
        autenticarComCustomToken: () => undefined,
        senha: {
            enviarEmailRedefinirSenha: () => undefined,
            erroEnviarEmailRedefinirSenha: null,
            sucessoEnviarEmailRedefinirSenha: false,
            retornoEnviarEmailRedefinirSenhaRetorno: null,
            loadingRedefinirSenha: false,
        },
        cadastrarInvestidor: () => {
            /* Vazia Inicialmente */
        },
        erroCadastroInvestidor: null,
        retornoCadastroInvestidor: null,
        loadingCadastroInvestidor: false,
        necessarioAceitarTermos: false,
        loadingSSO: false,
        loadingBuscarPessoa: false,
        customToken: '',
        tokenComErro: false,
    };
    const [dadosAutenticacao, setDadosAutenticacao] = react_1.useState(dadosAutenticacaoEstadoInicial);
    const { pessoa, usuarioFirebase, customToken, erro, organizacao, possuiSenha, necessarioEnviarNomeDaMae, erroValidacaoNomeDaMae, necessarioAceitarTermos, tokenComErro, } = dadosAutenticacao;
    const { loading: loadingSSO, erro: erroAuthReq, retorno: retornoAuthReq, send: sendAuthReq, } = fetch_1.default({
        method: 'POST',
        url: '/api/auth',
    });
    const { loading: loadingBuscarPessoa, erro: erroPessoaReq, retorno: retornoPessoaReq, send: sendPessoaReq, } = fetch_1.default({
        method: 'GET',
        url: '/api/pessoa/byTokenAutenticacao',
    });
    const { loading: loadingRedefinirSenhaReq, erro: erroRedefinirSenhaReq, retorno: retornoRedefinirSenhaReq, send: sendRedefinirSenhaReq, } = fetch_1.default({
        method: 'POST',
        url: '/api/email/reset-senha',
    });
    const { loading: loadingCadastroInvestidorReq, erro: erroCadastroInvestidorReq, retorno: retornoCadastroInvestidorReq, send: sendCadastroInvestidorReq, } = fetch_1.default({
        method: 'POST',
        url: '/api/pessoa/investidor',
    });
    /**
     * Função genérica que inicia o fluxo de autenticação a partir de:
     * email e senha
     * documento, data nascimento e nome da mãe
     * documento, data nascimento, nome da mãe e token da url
     * **/
    const autenticar = ({ email, documento, senha, dataNascimento, nomeMae, token, cnpjOrganizacao, backoffice = false, }) => {
        setLoading(true);
        setDadosAutenticacao(dadosAutenticacaoEstadoInicial);
        const login = email || documento;
        sendAuthReq(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (login && { login })), (senha && { senha })), (dataNascimento && { dataNascimento })), (nomeMae && { nomeMae })), (token && { token })), (cnpjOrganizacao && { cnpjOrganizacao })), (backoffice && { backoffice })));
    };
    /**
     * Função responsável por realizar signout do usuário firebase autenticado
     * Após o signout com sucesso a função "onLogout" é disparada
     * **/
    const signout = async () => {
        try {
            await firebase.auth().signOut();
        }
        finally {
            setDadosAutenticacao(dadosAutenticacaoEstadoInicial);
            onLogout();
        }
    };
    /**
     * Função que inicia o fluxo de autenticação a partir de um custom token
     * **/
    const autenticarComCustomToken = (customToken) => {
        setLoading(true);
        setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacaoEstadoInicial), { customToken }));
    };
    /**
     * Função responsável por enviar o email de redefinição de senha
     * **/
    const enviarEmailRedefinirSenha = ({ login, cnpjOrganizacao, }) => {
        sendRedefinirSenhaReq(Object.assign({ login }, (cnpjOrganizacao && { cnpjOrganizacao })));
    };
    /**
     * Função responsável por realizar cadastro do investidor
     * **/
    const cadastrarInvestidor = ({ nome, email, documento, senha, }) => {
        sendCadastroInvestidorReq({ nome, email, documento, senha });
    };
    /**
     * ETAPA 1
     * Identifica custom token a partir do response do SSO
     * Seta custom token no estado do hook
     * **/
    react_1.useEffect(() => {
        if (retornoAuthReq) {
            const { customToken } = retornoAuthReq;
            setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { customToken }));
        }
    }, [retornoAuthReq]);
    /**
     * Função responsável por realizar a autenticação do usuário a partir de um custom token
     * Após o login feito com sucesso, o token de autenticação é persistido no localStorage (tokenAutenticacao)
     * O usuário firebase autenticado é setado no estado do hook
     * **/
    const signinWithCustomToken = async (customToken) => {
        try {
            window.localStorage.setItem('customToken', customToken);
            const { user } = await firebase.auth().signInWithCustomToken(customToken);
            const idToken = await (user === null || user === void 0 ? void 0 : user.getIdToken());
            if (idToken) {
                window.localStorage.setItem('tokenAutenticacao', idToken);
            }
            setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { usuarioFirebase: user }));
        }
        catch (err) {
            console.error('signinWithCustomToken: Ocorreu um erro ao realizar login com token', err);
            window.localStorage.removeItem('tokenAutenticacao');
            window.localStorage.removeItem('customToken');
            setDadosAutenticacao(dadosAutenticacaoEstadoInicial);
        }
    };
    /**
     * ETAPA 2
     * Realiza login no firebase
     * Seta o usuario firebase no estado do hook
     * **/
    react_1.useEffect(() => {
        if (customToken) {
            signinWithCustomToken(customToken);
        }
    }, [customToken]);
    /**
     * ETAPA 3
     * Dispara envio de requisição para buscar dados da pessoa logada
     * **/
    react_1.useEffect(() => {
        if (usuarioFirebase) {
            sendPessoaReq();
        }
    }, [usuarioFirebase]);
    /**
     * ETAPA 4
     * Realiza o parse do retorno da api de pessoa
     * Seta as informações no estado do hook: pessoa e organizacao
     * Dispara função "onUsuarioLogin"
     * **/
    react_1.useEffect(() => {
        if (retornoPessoaReq) {
            const { pessoa: retornoPessoa, organizacao: retornoOrganizacao, } = retornoPessoaReq;
            setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { pessoa: retornoPessoa, organizacao: retornoOrganizacao }));
            setLoading(false);
            onUsuarioLogin({
                usuarioFirebase,
                pessoa: retornoPessoa,
                organizacao: retornoOrganizacao,
            });
        }
    }, [retornoPessoaReq]);
    /**
     * Função responsável por verificar se o tomador precisa aceitar os termos da plataforma a partir de um request error do axios
     * **/
    const verificaSeTomadorPrecisaAceitarTermos = (err) => {
        try {
            const { response: { status, data: { erros: [{ codigo }], }, }, } = err;
            return status === 401 && codigo === 'TERMO001';
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Função responsável por verificar token com erro
     * **/
    const verificaTokenComErro = (err) => {
        try {
            const { response: { status, data: { erros: [{ codigo }], }, }, } = err;
            return status === 401 && codigo === 'AUTH010';
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Realiza tratativas de erros para a api de pessoa
     * Seta erro no estado do hook
     * Seta informação se usuário precisa aceitar termos no estado do hook
     * **/
    react_1.useEffect(() => {
        if (erroPessoaReq) {
            const precisaAceitarTermos = verificaSeTomadorPrecisaAceitarTermos(erroPessoaReq);
            const tokenPossuiErro = verificaTokenComErro(erroPessoaReq);
            if (precisaAceitarTermos) {
                setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { necessarioAceitarTermos: true }));
            }
            else if (tokenPossuiErro) {
                setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { tokenComErro: true }));
            }
            else {
                setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { erro: erroPessoaReq }));
            }
            // signout();
            setLoading(false);
        }
    }, [erroPessoaReq]);
    /**
     * Função responsável por tratar os possíveis erros conhecidos ao realizar login, a partir de um objeto request error do axios
     * Realiza validação: usuário já possui senha
     * Realiza validação: usuário precisa enviar nome da mãe
     * Realiza validação: nome da mãe incorreto
     * Extrai descrição do erro a partir do objeto de response
     * **/
    const tratarErroLogin = (err) => {
        var _a;
        if (!((_a = erroAuthReq === null || erroAuthReq === void 0 ? void 0 : erroAuthReq.response) === null || _a === void 0 ? void 0 : _a.data)) {
            setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { erro: 'Houve um Erro Inesperado. Por favor, tente novamente.' }));
            return;
        }
        const { response: { data: { codigo, descricao, perfis }, status, }, } = err;
        const usuarioPossuiSenha = status === 401 && codigo === 'SSO001';
        if (status === 401 && codigo === 'SSO035') {
            setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacao), { perfis }));
        }
        const necessarioEnviarNomeDaMae = status === 401 && codigo === 'SSO023';
        const erroValidacaoNomeDaMae = status === 401 && codigo === 'SSO024';
        setDadosAutenticacao(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, dadosAutenticacao), (usuarioPossuiSenha && { possuiSenha: true })), (necessarioEnviarNomeDaMae && { necessarioEnviarNomeDaMae: true })), (erroValidacaoNomeDaMae && { erroValidacaoNomeDaMae: true })), (descricao && { erro: descricao })));
    };
    /**
     * Realiza tratativas de erros para api do SSO
     * **/
    react_1.useEffect(() => {
        if (erroAuthReq) {
            tratarErroLogin(erroAuthReq);
            setLoading(false);
        }
    }, [erroAuthReq]);
    /**
     * Função responsável por buscar pessoa e organização a partir de um objeto usuário firebase autenticado
     * **/
    const recuperarPessoaEOrganizacaoPorUsuario = (usuario) => {
        setDadosAutenticacao(Object.assign(Object.assign({}, dadosAutenticacaoEstadoInicial), { usuarioFirebase: usuario }));
    };
    return {
        recuperarPessoaEOrganizacaoPorUsuario,
        autenticar,
        customToken,
        pessoa,
        organizacao,
        usuarioFirebase,
        erro,
        possuiSenha,
        loading,
        signout,
        necessarioEnviarNomeDaMae,
        erroValidacaoNomeDaMae,
        autenticarComCustomToken,
        senha: {
            enviarEmailRedefinirSenha,
            erroEnviarEmailRedefinirSenha: erroRedefinirSenhaReq,
            sucessoEnviarEmailRedefinirSenha: !!(retornoRedefinirSenhaReq && retornoRedefinirSenhaReq.email),
            retornoEnviarEmailRedefinirSenhaRetorno: retornoRedefinirSenhaReq,
            loadingRedefinirSenha: loadingRedefinirSenhaReq,
        },
        cadastrarInvestidor,
        erroCadastroInvestidor: erroCadastroInvestidorReq,
        retornoCadastroInvestidor: retornoCadastroInvestidorReq,
        loadingCadastroInvestidor: loadingCadastroInvestidorReq,
        necessarioAceitarTermos,
        buscarPessoa: sendPessoaReq,
        loadingSSO,
        loadingBuscarPessoa,
        tokenComErro,
    };
};
exports.default = useAuth;
//# sourceMappingURL=index.js.map